import expandedMenuIcon from '../images/expanded-menu-icon.svg'
import { RoutePath } from '../../../constants'
import NavMenuItem from './NavMenuItem'

interface MobileMenuProps {
  onNavigate: (path: string) => void
  onIsMenuOpenChange: (state: boolean) => void
}

function MobileMenu({ onNavigate, onIsMenuOpenChange }: MobileMenuProps) {
  return (
    <div className="absolute h-screen bg-green z-[110] w-[355px] top-0 right-0">
      <div className="flex flex-row mt-32">
        <div className="w-[71px]" />
        <div className="flex flex-col gap-8 flex-1">
          <button
            type="button"
            onClick={() => onIsMenuOpenChange(false)}
            className="flex flex-row items-center absolute top-[64px] right-[45px]"
          >
            <img src={expandedMenuIcon} alt="Single line" />
            <span
              className={
                'font-decimal text-[16px] font-bold pl-3 text-white tracking-[.96px]'
              }
            >
              MENU
            </span>
          </button>
          <NavMenuItem label="Home" onNavigate={() => onNavigate('/')} />
          <NavMenuItem
            label="Map"
            onNavigate={() => onNavigate(RoutePath.Map)}
          />
          <NavMenuItem
            label="Table"
            onNavigate={() => onNavigate(RoutePath.Table)}
          />
          <NavMenuItem
            label="About"
            onNavigate={() => onNavigate(RoutePath.About)}
          />
          <NavMenuItem
            label="+ Organization"
            onNavigate={() => onNavigate(RoutePath.AddOrganization)}
          />
        </div>
      </div>
    </div>
  )
}

export default MobileMenu
